import React, { Component } from "react";
import { v4 as uuidv4 } from "uuid";
import LdsAccordion from "../components/LdsAccordion";
import LdsTile from "../components/LdsTile";

class Home extends Component {
  render() {
    return (
      <main>
        <section className="section row">
          <div className="col-sm-12 col-md-6 offset-md-3" id="mim-setup">
            <h1 className="b text-uppercase mb-5">Mim Setup Instructions</h1>
            <p>
              This training uses MIM Referring software. As there are
              differences between the commercially available software, please
              consult your specific software manufacturer for more detailed
              training and orientation.
            </p>
            <p>
              Follow these step-by-step instructions to set up MIM Referring
              software on your computer or download the MIM Setup Guides linked
              below.
            </p>
            <h2 className="b mt-5">
              MIM referring desktop log-in instructions
            </h2>
            <ol>
              <li>
                Please click the appropriate link to download the MIM Referring
                software.*
                <ul className="ms-0 mt-2">
                  <li><a href="https://downloads.mimsoftware.com/MIM7.4.2_buildOA10-09.exe" target="_blank" className="orange b" rel="noreferrer">PC: MIM Referring software download link</a></li>
                  <li><a href="https://downloads.mimsoftware.com/MIM7.4.2_buildOA10-09.dmg" target="_blank" className="orange b" rel="noreferrer">Mac: MIM Referring software download link</a></li>
                </ul>
              </li>
              <li>
                For PC users, click “Run” to begin the download and follow the
                installation instructions. For Mac users, click on the
                downloaded .dmg file and then click on the PKG file to begin the
                installation.
                <ul className="ms-0 mt-2">
                  <li>Use the password “clarke” when prompted to enter a password for the encrypted file</li>
                </ul>
              </li>
              <li>
                Once the installation completes, click “Close” as you do not
                need to launch or log into the MIM Referring software at this
                time.
              </li>
              <li>
                On the following screens, direct links will be provided to cases
                for your review. If you are prompted for a username and password
                after clicking on the direct links to the cases, enter:
                <ul className="ms-0 mt-2">
                  <li>E-mail address: amyvidtraining@amyvidtraining.com</li>
                  <li>Password (case sensitive): Amyvid2012</li>
                </ul>
              </li>
            </ol>
            <p>
              Do not close this training window when you navigate to the MIM
              Referring software; you will need both windows open at the same
              time.
            </p>
            <p>
              *This training uses MIM Referring software. As there are
              differences between the commercially available software, please
              consult your specific software manufacturer for more detailed
              training and orientation.
            </p>
            <h2 className="b mb-3 mt-5">Mobile MIM setup instructions</h2>
            <ol className="ms-0">
              <li>
                Please go to the App Store and search “Mobile MIM” to download
                the Mobile MIM app.
              </li>
              <li>After installing the app, follow these steps:</li>
            </ol>
            <p>
              Step 1. Launch the <strong>Mobile MIM</strong> app
            </p>
            <p>
              Step 2. Tap <strong>Access Non-Diagnostic Mode</strong> and then
              tap <strong>OK</strong> to skip registration
            </p>
            <p>
              Step 3. Tap <strong>Connect to MIMcloud</strong>
            </p>
            <p>
              Step 4. Enter <strong>amyvidtraining@amyvidtraining.com</strong>{" "}
              in the <strong>Email Address</strong> field
            </p>
            <p>
              Step 5. Enter <strong>Amyvid2012</strong> in the{" "}
              <strong>Password</strong> field
            </p>
            <p>
              Step 6. Tap <strong>Log In</strong>
            </p>
            <p>
              Step 7. Tap <strong>MIMcloud</strong>
            </p>
          </div>
        </section>
        <section className="section gray-tile">
          <div className="col-sm-12 col-md-6 offset-md-3">
            <h2 className="b text-center mb-5">
              Amyvid<sup>&reg;</sup> frequently asked questions
            </h2>
            <div id="AccordionGroupContainer" className="content-block">
              <LdsAccordion accordionId="accordion1">
                <LdsAccordion.Header accordionId="accordion1">
                  <span className="lds-text-action mb-0">
                    Why am I having issues registering/signing in?
                  </span>
                </LdsAccordion.Header>
                <LdsAccordion.Body accordionId="accordion1">
                  <p>
                    To access reader training, you need to{" "}
                    <a href={`/register/${uuidv4()}`}>register</a>
                  </p>
                  <ul>
                    <li>First name</li>
                    <li>Last name</li>
                    <li>Street address</li>
                    <li>City</li>
                    <li>State</li>
                    <li>Zip Code</li>
                    <li>Specialty </li>
                    <li>Email address</li>
                    <li>Password</li>
                  </ul>
                  <p>
                    We will add your first and last name to your Certificate of
                    Completion. If you forget your password, we can send you a
                    password reset email to your email address. View our{" "}
                    <a
                      href="https://privacynotice.lilly.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      privacy policy
                    </a>{" "}
                    for more info on collecting and storing information.
                  </p>
                </LdsAccordion.Body>
              </LdsAccordion>
              <LdsAccordion accordionId="accordion2">
                <LdsAccordion.Header accordionId="accordion2">
                  <span className="lds-text-action mb-0">
                    What should I do if I received an email but don’t remember
                    my password?
                  </span>
                </LdsAccordion.Header>
                <LdsAccordion.Body accordionId="accordion2">
                  <p>
                    Click the “Forgot Your Password?” link, enter the email
                    address that you registered with, and click the “Submit”
                    button. You will receive an email with your password.
                  </p>
                </LdsAccordion.Body>
              </LdsAccordion>
              <LdsAccordion accordionId="accordion3">
                <LdsAccordion.Header accordionId="accordion3">
                  <span className="lds-text-action mb-0">
                    How long will the training take to complete?
                  </span>
                </LdsAccordion.Header>
                <LdsAccordion.Body accordionId="accordion3">
                  <p>
                    On average, this online reader training program will take
                    2-3 hours to complete. You can stop and start it as you
                    wish. The program will keep your place.
                  </p>
                </LdsAccordion.Body>
              </LdsAccordion>
              <LdsAccordion accordionId="accordion4">
                <LdsAccordion.Header accordionId="accordion4">
                  <span className="lds-text-action mb-0">
                    Which devices and browsers work with this training?
                  </span>
                </LdsAccordion.Header>
                <LdsAccordion.Body accordionId="accordion4">
                  <p>
                    The Amyvid Reader Training site is a browser-based site that
                    is compatible on tablet, laptop, and desktop platforms.
                    Mobile devices are not supported, and the required software
                    will not function correctly on these devices. Please review
                    and complete the training on a laptop or desktop computer.
                  </p>
                  <p>
                    We recommend using one of the following supported browsers:
                  </p>
                  <ul>
                    <li>Chrome v54 and greater </li>
                    <li>Firefox v65 and greater </li>
                    <li>Safari v16 and greater</li>
                    <li>Edge v18 and greater</li>
                  </ul>
                  <p>
                    Please note that the Internet Explorer (IE) browser is not
                    supported.
                  </p>
                </LdsAccordion.Body>
              </LdsAccordion>
              <LdsAccordion accordionId="accordion5">
                <LdsAccordion.Header accordionId="accordion5">
                  <span className="lds-text-action mb-0">
                    Where can I find instructions on how to set up MIM Referring
                    software?
                  </span>
                </LdsAccordion.Header>
                <LdsAccordion.Body accordionId="accordion5">
                  <p>
                    You can find step-by-step instructions for setting up MIM
                    Referring software on our MIM Setup page,{" "}
                    <a href="#mim-setup">mim-setup</a>.
                  </p>
                </LdsAccordion.Body>
              </LdsAccordion>
              <LdsAccordion accordionId="accordion6">
                <LdsAccordion.Header accordionId="accordion6">
                  <span className="lds-text-action mb-0">
                    Why does MIM close while trying to load a PET scan?
                  </span>
                </LdsAccordion.Header>
                <LdsAccordion.Body accordionId="accordion6">
                  <p>
                    After multiple PET scan downloads, this has occurred with
                    iPad<sup>&reg;</sup> devices. Consider switching to either a
                    laptop or desktop device.
                  </p>
                </LdsAccordion.Body>
              </LdsAccordion>
              <LdsAccordion accordionId="accordion7">
                <LdsAccordion.Header accordionId="accordion7">
                  <span className="lds-text-action mb-0">
                    Why is it taking so long to load the PET scans?
                  </span>
                </LdsAccordion.Header>
                <LdsAccordion.Body accordionId="accordion7">
                  <p>
                    This is usually a limitation of the device resources.
                    Consider switching to a different device.
                  </p>
                </LdsAccordion.Body>
              </LdsAccordion>
              <LdsAccordion accordionId="accordion8">
                <LdsAccordion.Header accordionId="accordion8">
                  <span className="lds-text-action mb-0">
                    What type of certification do I receive for completing the
                    Amyvid Online Reader Training Program?
                  </span>
                </LdsAccordion.Header>
                <LdsAccordion.Body accordionId="accordion8">
                  <p>
                    A personalized Certificate of Completion will be given to
                    healthcare professionals who complete the Amyvid Reader
                    Training Program in its entirety. We’ll email the
                    certification immediately after completion of the online
                    training.
                  </p>
                </LdsAccordion.Body>
              </LdsAccordion>
              <LdsAccordion accordionId="accordion9">
                <LdsAccordion.Header accordionId="accordion9">
                  <span className="lds-text-action mb-0">
                    Do I receive Continuing Medical Education (CME) credit for
                    completing the Amyvid Reader Training Program?
                  </span>
                </LdsAccordion.Header>
                <LdsAccordion.Body accordionId="accordion9">
                  <p>No. This training is not accredited for CME.</p>
                </LdsAccordion.Body>
              </LdsAccordion>
              <LdsAccordion accordionId="accordion10">
                <LdsAccordion.Header accordionId="accordion10">
                  <span className="lds-text-action mb-0">
                    Who can I contact if I have a question about this site or
                    need technical support?
                  </span>
                </LdsAccordion.Header>
                <LdsAccordion.Body accordionId="accordion10">
                  <p>
                    If you need assistance or technical support for the Amyvid Reader Training site, please call the Lilly Answers Center at LillyRx (1-800-545-5979).
                  </p>
                </LdsAccordion.Body>
              </LdsAccordion>
              <LdsAccordion accordionId="accordion11">
                <LdsAccordion.Header accordionId="accordion11">
                  <span className="lds-text-action mb-0">
                    How can I get live support setting up or reading an Amyvid
                    scan?
                  </span>
                </LdsAccordion.Header>
                <LdsAccordion.Body accordionId="accordion11">
                  <p>
                    For live assistance from a member of the Lilly medical staff
                    on scan setup or interpretation, please contact the Lilly
                    Answers Center at 1-800-LillyRx (1-800-545-5979).
                  </p>
                </LdsAccordion.Body>
              </LdsAccordion>
            </div>
          </div>
        </section>
        <section className="section">
          <h2 className="b text-center mb-4">Technical requirements</h2>
          <div className="row">
            <div className="col-sm-12 col-md-6 offset-md-3">
              <p>
                Please be sure you have reviewed the technical requirements and
                navigation instructions before continuing with this module
              </p>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col col-md-10 offset-md-1">
              <div className="row">
                <LdsTile
                  ariaLabel="Supported Browsers"
                  className="col-sm-12 col-md-4 white-tile"
                  role="region"
                >
                  <LdsTile.Body>
                    <div
                      style={{
                        height: '160px',
                        borderRadius: '16px',
                      }}
                      className="m-4"
                    >
                      <p className="fz-lg b">Supported Browsers</p>
                      <p className="fz-md">
                        <ul>
                          <li>Google Chrome v54 and greater</li>
                          <li>Firefox v65 and greater</li>
                          <li>Safari v16 and greater</li>
                          <li>Microsoft Edge v18 and greater</li>
                        </ul>
                      </p>
                    </div>
                  </LdsTile.Body>
                </LdsTile>
                <LdsTile
                  ariaLabel="Other Requirements"
                  className="col-sm-12 col-md-4 white-tile"
                  role="region"
                >
                  <LdsTile.Body>
                    <div
                      style={{
                        height: "160px",
                        borderRadius: "16px",
                      }}
                      className="m-4"
                    >
                      <p className="fz-lg b">Other Requirements</p>
                      <p className="fz-md">
                        <ul>
                          <li>Adobe Acrobat (current version)</li>
                          <li>Java (current version)</li>
                        </ul>
                      </p>
                    </div>
                  </LdsTile.Body>
                </LdsTile>
                <LdsTile
                  ariaLabel="test-aria"
                  className="col-sm-12 col-md-4 white-tile"
                  role="region"
                >
                  <LdsTile.Body>
                    <div
                      style={{
                        borderRadius: "12px",
                      }}
                      className="m-4"
                    >
                      <p className="fz-lg b">
                        Operating Systems & Requirements
                      </p>
                      <p className="fz-md">
                        <ul>
                          <li>Windows 10</li>
                          <li>MacOS 11 (Big Sur)</li>
                          <li>iOS 16.1.1 (iPad Air recommended)</li>
                          <li>8 GB minimum system RAM</li>
                        </ul>
                      </p>
                    </div>
                  </LdsTile.Body>
                </LdsTile>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default Home;
